import axios from 'axios';
import '/src/services/axios-interceptor';
import authHeader from '/src/services/auth-header';
//src\services\auth-header.js
//const API_URL = 'http://localhost:8080/api/admin/';
const API_URL = process.env.VUE_APP_BASE_URL_API + '/admin/';

class AdminService {

   getAppMembers( userAppModuleId ) {
      return axios.get(API_URL + 'get_app_members',
         { 
            params: {
               userAppModuleId: userAppModuleId
            },
            headers: authHeader() 
         }
      );
   }

   getPublicContent() {
      return axios.get(API_URL + 'all');
   }

   getUserAppModules(userId) {
      return axios.get(API_URL + `userappmodules/${userId}`, { headers: authHeader() });
   }
   //`/prestacion/getbycodigo/${codigo}`
   moduleIn(userId, moduleId) {
      let arrLong = [userId, moduleId];
      return axios
         .get(API_URL + `userappmodule/${arrLong}`,  { headers: authHeader() })
         .then(response => {
            if (response.data.appModule) {
               //console.log(response.data.modules.name);
               localStorage.setItem('userAppModule', JSON.stringify(response.data));
            }
            //console.log(response.data);
            return response.data;
         });
   }
   
   moduleOut() {
      localStorage.removeItem('userAppModule');
   }
}

export default new AdminService();